(function() {
  'use strict';

  // Mobile menu toggle
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      const isOpen = mobileMenu.getAttribute('data-open') === 'true';
      mobileMenu.setAttribute('data-open', !isOpen);
      menuToggle.setAttribute('aria-expanded', !isOpen);
    });
  }

  // Sticky header shadow
  const header = document.querySelector('#SiteHeader');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.setAttribute('data-scrolled', 'true');
      } else {
        header.setAttribute('data-scrolled', 'false');
      }
    }, { passive: true });
  }

  // Quick Add to Cart
  document.querySelectorAll('.btn-quick-add').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        btn.textContent = 'Added!';
        // Update cart count
        fetch(window.routes.cart_url + '.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            const countEl = document.querySelector('[data-cart-count]');
            if (countEl) countEl.textContent = cart.item_count;
          });
        setTimeout(function() {
          btn.textContent = 'Quick Add';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        btn.textContent = 'Error';
        setTimeout(function() {
          btn.textContent = 'Quick Add';
          btn.disabled = false;
        }, 2000);
      });
    });
  });

  // Product variant selection
  const variantSelects = document.querySelectorAll('.variant-select');
  if (variantSelects.length > 0) {
    // Simple variant matching - updates URL on change
    variantSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        // Get all selected options
        const selectedOptions = [];
        variantSelects.forEach(function(s) {
          selectedOptions.push(s.value);
        });
        // Try to find matching variant in product data
        if (window.productVariants && selectedOptions.length > 0) {
          const match = window.productVariants.find(function(v) {
            return v.options.every(function(opt, i) {
              return opt === selectedOptions[i];
            });
          });
          if (match) {
            const addBtn = document.querySelector('.product-add-btn');
            const hiddenId = document.querySelector('input[name="id"]');
            if (hiddenId) hiddenId.value = match.id;
            if (addBtn) {
              if (match.available) {
                addBtn.disabled = false;
                addBtn.textContent = 'Add to Cart';
              } else {
                addBtn.disabled = true;
                addBtn.textContent = 'Sold Out';
              }
            }
            // Update URL
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', newUrl);
          }
        }
      });
    });
  }

  // Newsletter form (AJAX)
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      // Let Shopify handle it natively for now
    });
  }

  // Announcement bar rotation
  const announcements = document.querySelectorAll('.announcement-item');
  if (announcements.length > 1) {
    let current = 0;
    announcements.forEach(function(el, i) {
      el.style.display = i === 0 ? 'inline-block' : 'none';
    });
    setInterval(function() {
      announcements[current].style.display = 'none';
      current = (current + 1) % announcements.length;
      announcements[current].style.display = 'inline-block';
    }, 5000);
  }
})();
